import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import {
  DELETE_JUSTIFICATION_EMPLOYEE,
  GET_ONE_JUSTIFICATION_EMPLOYEE_BY_ID,
  GET_TYPES_OF_JUSTIFICATIONS,
  REGISTER_JUSTIFICATION_EMPLOYEE,
  UPDATE_JUSTIFICATION_EMPLOYEE,
} from '../../../../../../graphql/Catalog/Employees/Justifications/employeesJustifications'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import { FormProvider, useForm } from 'react-hook-form'
import Box from '../../../../../Global/Box'
import InputController from '../../../../../Global/InputController'
import { useMutation, useQuery } from '@apollo/client'
import moment from 'moment'
const FormJustification = ({
  logId,
  justificationId,
  setCloseModal,
  refetchLogs,
}) => {
  const { hideLoading, showLoading } = useLoading()

  const [files, setFiles] = useState([])
  const [options, setOptions] = useState({
    justificationsTypes: [],
  })

  const validationSchema = Yup.object().shape({
    justification_type: Yup.string().required(
      'Tipo de justificante es requerido'
    ),
    description: Yup.string().required('Descripción es requerida'),
    document_url: Yup.array()
      .required('Archivo es requerido')
      .min(1, 'Archivo es requerido')
      .typeError('Archivo es requerido'),
    justification_date: Yup.string().required(
      'Fecha de justificante es requerida'
    ),
  })

  console.log('files', files)

  const {
    methods,
    handleSubmit,
    setValue,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const {
    loading: loadingJustification,
    error: errorJustification,
    data: dataJustification,
  } = useQuery(GET_TYPES_OF_JUSTIFICATIONS, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingJustificationById,
    error: errorJustificationById,
    data: dataJustificationById,
  } = useQuery(GET_ONE_JUSTIFICATION_EMPLOYEE_BY_ID, {
    variables: {
      getEmployeeJustificationByIdId: +justificationId,
    },
    skip: !justificationId,
    fetchPolicy: 'cache-and-network',
  })

  const [createJustification] = useMutation(REGISTER_JUSTIFICATION_EMPLOYEE)
  const [updateJustification] = useMutation(UPDATE_JUSTIFICATION_EMPLOYEE)
  const [deleteJustification] = useMutation(DELETE_JUSTIFICATION_EMPLOYEE)

  useEffect(() => {
    try {
      if (loadingJustification) return
      if (errorJustification) throw new Error(errorJustification.message)

      setOptions((prev) => ({
        ...prev,
        justificationsTypes: dataJustification.getTypesOfJustifications,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingJustification, errorJustification, dataJustification])

  useEffect(() => {
    try {
      if (!justificationId) return
      if (loadingJustificationById) return
      if (errorJustificationById)
        throw new Error(errorJustificationById.message)
      const justificationData =
        dataJustificationById.getEmployeeJustificationById

      reset({
        justification_type: justificationData.justification_type,
        description: justificationData.description,
        document_url: [justificationData.document_url],
        justification_date: moment(
          justificationData.justification_date,
          'YYYY-MM-DDTHH:mm:ss'
        ).format('YYYY-MM-DD'),
      })
      setValue(
        'justification_date',
        moment(justificationData.justification_date).format('YYYY-MM-DD')
      )

      const file = [
        {
          id: justificationData.id,
          src: justificationData.document_url,
          name: justificationData.document_url.split('/').pop(),
          type: 'image/jpeg', // Assuming the file is a JPEG, adjust as necessary
        },
      ]

      setFiles(file)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingJustificationById, errorJustificationById, dataJustificationById])

  const handleDeleteJustification = async () => {
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        message: '¿Está seguro de eliminar este justificante?',
        btnCancelText: 'Cancelar',
        btnConfirmText: 'Eliminar',
        icon: 'warning',
        title: 'Eliminar Justificante',
      })

      if (!response.isConfirmed) return

      showLoading()

      const { data: responseDelete } = await deleteJustification({
        variables: {
          deleteEmployeeJustificationId: +justificationId,
        },
        fetchPolicy: 'no-cache',
      })

      if (responseDelete.deleteEmployeeJustification) {
        await refetchLogs()
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Justificante eliminado correctamente',
          },
          setCloseModal(true)
        )
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const onSubmit = async (data) => {
    showLoading()
    try {
      console.log('data', data)
      const file = data.document_url[0]
      console.log('file', file)

      if (justificationId) {
        const { data: responseUpdate } = await updateJustification({
          variables: {
            input: {
              log_id: +logId,
              justification_type: data.justification_type,
              description: data.description,
              document_url: file.id ? null : file,
              justification_date: data.justification_date,
            },
            updateEmployeeJustificationId: +justificationId,
          },
        })

        if (responseUpdate.updateEmployeeJustification) {
          await refetchLogs()
          return toastSweetAlert(
            {
              mode: 'ok',
              message: 'Justificante actualizado correctamente',
            },
            setCloseModal(true)
          )
        }
      }

      const { data: responseCrate } = await createJustification({
        variables: {
          input: {
            log_id: +logId,
            justification_type: data.justification_type,
            description: data.description,
            document_url: file.id ? null : file,
            justification_date: data.justification_date,
          },
        },
      })

      if (responseCrate.createEmployeeJustification) {
        await refetchLogs()
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Justificante registrado correctamente',
          },
          setCloseModal(true)
        )
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          withCard={false}
          title=""
          btnSubmit
          btnSubmitText={
            justificationId
              ? 'Actualizar Justificante'
              : 'Registrar Justificante'
          }
          content={
            <>
              {justificationId && (
                <div className="d-flex justify-content-end mb-3">
                  <span
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDeleteJustification}
                  >
                    Eliminar Justificante
                  </span>
                </div>
              )}
              <div className="row">
                <div className="mb-3 col-lg-6">
                  <InputController
                    name="justification_type"
                    control={control}
                    label="Tipo de Justificante"
                    inputType="choosen"
                    options={options.justificationsTypes}
                    placeholder="Seleccione un tipo de justificante"
                  />
                </div>
                <div className="mb-3 col-lg-6">
                  <InputController
                    name="justification_date"
                    control={control}
                    label="Fecha de Justificante"
                    type="date"
                    placeholder="Seleccione una fecha"
                  />
                </div>
                <div className="mb-3 col-lg-12">
                  <InputController
                    name="description"
                    control={control}
                    label="Descripción"
                    inputType="textarea"
                    placeholder="Ingrese una descripción del justificante"
                  />
                </div>
                <div className="mb-3 col-lg-12">
                  <InputController
                    name="document_url"
                    control={control}
                    label="Adjuntar Justificante"
                    inputType="attachment"
                    editDropAttachment={
                      files.length > 0 && justificationId ? files : false
                    }
                    setFilesEdit={setFiles}
                  />
                </div>
              </div>
            </>
          }
        />
      </form>
    </FormProvider>
  )
}

export default FormJustification
